
//import 'datatables.net';
//import '../components/hs-datatables';
import '../components/hs-validation';
export default {

  init() {

  },
  finalize() {

    $('table[name=assessment-form-table]').each(function () {

      // add class to checked inputs
      if ($("input.likert-choice", this).is(":checked")) {
        $("td input:checked", this).parent().addClass("mychoice remove-after");
      }

      // add a selected class to the parent list item
      $("input.likert-choice", this).on('change', function () {
        if ($(this).is(":checked")) {
          $(this).parent().parent().find(".mychoice").removeClass("mychoice remove-after");
          $(this).parent().addClass("mychoice remove-after");
        }
      });

      // Cater for sloppy pointers
      $('td.choice', this).on('click', function (e) {
        if ($(e.target).is('input:radio')) {
          e.stopPropagation();
          // Only remove the error if the radio button itself is clicked!
          $('input:radio', this).parent().parent().find(".invalid-feedback").hide(); // Hide error
        } else {
          if ($('input:radio', this).prop('checked') === true) {
            return false;
            // Don't do anything if it's already checked!
          }
          if ($('input:radio', this).hasClass('locked')) {
            return false;
            // Don't do anything if it's disabled!
          }
          $('input:radio', this).prop('checked', true); // Check the radio
          $('input:radio', this).parent().parent().find(".mychoice").removeClass("mychoice remove-after"); // Remove class
          $('input:radio', this).parent().parent().find(".invalid-feedback").hide(); // Hide error
          $("td input:checked").parent().addClass("mychoice remove-after"); // Set the input class
        }
      });

    });

    // changing feedback survey highlight functionality
    let isScrollToTopActive = false;
    let delay = 3000;
    $.HSCore.components.HSValidation.init('.js-validate-feedback', {
      setDefaults: {
        ignore: [],
        doNotHideMessage: true,
      },
      rules: {
        startDateCalendar: {
          required: true
        },
        postcode: {
          remote: {
            url: ajaxdta.ajaxurl,
            data: ({
              'action': "verify_australian_postcode",
              'nonce': ajaxdta._nonce,
              postcode: function() {
                return $( "#postcode" ).val();
              }
            }),
          }
        },
        'response_populations[]': {
          required: true
        }
      },
      highlight : (element) => {
        //checking if wp admin bar is on the page and has position fixed
        if (!isScrollToTopActive){
          let questionTopOffset = $(element).parents('tr').offset().top;
          const hasAdminBar = $('#wpadminbar').length != 0 && $('#wpadminbar').css('position') == 'fixed';
          if (hasAdminBar){
            questionTopOffset -= $('#wpadminbar').height();
          }
          $('html, body').animate({
            scrollTop: questionTopOffset,
          }, 500, () => {
            isScrollToTopActive = false;
          })
          isScrollToTopActive = true;
        }
      },
      errorPlacement: function (error, element) { // render error placement for each input type
        if (element.parents('.form-check').size() > 0) {
          error.appendTo(element.parents('.form-check').attr("data-error-container"));
        }
        if (element.parents('.choice').size() > 0) {
          error.appendTo(element.parents('.choice').attr("data-error-container"));
        } else {
          error.insertAfter(element); // for other inputs, just perform default behavior
        }
      },
      submitHandler: function (form) {

        $.ajax({
          url: $(form).attr('action'),
          type: $(form).attr('method'),
          data: $(form).serializeArray(),
          dataType: 'json',

          // Hide stuff and show dropDownNotice
          beforeSend: function () {

            if( !$(form).hasClass('js-form-no-feedback') ) {
              $("html, body").animate({scrollTop: 0}, 'slow');
              $('.dropDownNoticeClose').trigger('click');
            }
            $(form).closest('div.js-form-hide-before-send').fadeOut('slow');

          },

          // Set ajax_result message
          success: function (response) {

            if ( response.success ) {
              $('#infoFormAlert').find('.response-message').addClass('alert-success');
            }
            else {
              $('#infoFormAlert').find('.response-message').addClass('alert-danger');
              if( $(form).hasClass('js-form-show-errors') ) {
                $("html, body").animate({scrollTop: 0}, 'slow');
                $('.dropDownNoticeClose').trigger('click');
                $(form).addClass('error');
              }
            }
            $('#infoFormAlert').find('.response-message').html(response.data.message);

            if(response.data.location){
              if(response.data.replaceLocation){
                window.setTimeout(function(){window.location.replace(response.data.location)}, 1300);
              }
              else{
                window.setTimeout(function(){window.location.href=response.data.location}, 1300);
              }
            }
          },

          // For debugging ajax connection issues.
          error: function (jqXHR, textStatus, errorThrown) {
            $(form).addClass('fatal-error');
            $("html, body").animate({scrollTop: 0}, 'slow');
            $('#infoFormAlert').find('.response-message').addClass('alert-danger');
            $('#infoFormAlert').find('.response-message').html('Sorry an unexpected communication error was detected.<br/>Please try again or' +
              ' contact our support team if this continues.');
            if( $(form).hasClass('js-form-no-feedback') ) {
              $('.dropDownNoticeClose').trigger('click');
            }
          },

          // hide spinner and show ajax_result
          complete: function () {
            let displayFeedBack = false;
            if(
              (!$(form).hasClass('js-form-no-feedback')) ||
              ( ($(form).hasClass('error')) && ($(form).hasClass('js-form-show-errors')) )
            ){
              displayFeedBack = true;
            } else if( $(form).hasClass('fatal-error') ){
              displayFeedBack = true;
            }

            if( displayFeedBack ){
              $('#ajaxSpinner').hide();
              $('#infoFormAlert').fadeIn('slow');
              setTimeout(function () {
                $('.dropDownNoticeClose').trigger('click');
                return false;
              }, delay);

            }
          }
        });

        // Don't redirect
        return false;
      }
    });

    $('#feedbackModal').modal('show');

    $('.modal-button').on("click", function(){
      $('#feedbackModal').modal('hide');
    });
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/feedback.js